import { render, staticRenderFns } from "./SightingsInfo.vue?vue&type=template&id=09b57ca0&scoped=true"
import script from "./SightingsInfo.vue?vue&type=script&lang=js"
export * from "./SightingsInfo.vue?vue&type=script&lang=js"
import style0 from "./SightingsInfo.vue?vue&type=style&index=0&id=09b57ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b57ca0",
  null
  
)

export default component.exports